import { render, staticRenderFns } from "./ImportModule.vue?vue&type=template&id=66b5261a&"
import script from "./ImportModule.vue?vue&type=script&lang=js&"
export * from "./ImportModule.vue?vue&type=script&lang=js&"
import style0 from "./ImportModule.vue?vue&type=style&index=0&id=66b5261a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports